import Button from "@mui/material/Button";

import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import { useMemo, useState } from "react";
import BorrowerCreditAndBackgroundReportForm from "../../../shared/forms/BorrowerCreditAndBackgroundReportForm";
import BasicModal from "../../modals/BasicModal";
import FilePreviewSideModal from "../../modals/FilePreviewSideModal";
import { useEnv } from "../../../hooks/useEnv";

const CellRendererPullCreditReportButton = (params) => {
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const applicationData = useMemo(() => params?.data, [params?.data]);

  console.log("applicationData", applicationData);
  const creditReportDoc = useMemo(() => {
    if (!isArray(applicationData?.documents)) {
      return null;
    }
    const filteredFile = applicationData?.documents?.find(
      (doc) => doc.docType === "Credit Report"
    );
    if (isObject(filteredFile)) {
      return filteredFile;
    }
    return null;
  }, [applicationData]);

  const isSubmitted = useMemo(() => {
    if (isObject(creditReportDoc)) {
      return true;
    }

    return false;
  }, [creditReportDoc]);

  const buttonStyles = useMemo(() => {
    return { px: 1.2, py: 0.4, flexGrow: 1 };
  }, []);

  const buttonVariant = useMemo(
    () => (isSubmitted ? "contained" : "outlined"),
    [isSubmitted]
  );
  const buttonText = useMemo(
    () => (isSubmitted ? "View Background" : "Pull Background"),
    [isSubmitted]
  );

  const onClickHandler = () => {
    if (isSubmitted) {
      setFile(creditReportDoc);
      return;
    }
    setShow(true);
  };

  return (
    <>
      <Button
        onClick={onClickHandler}
        variant={buttonVariant}
        size="small"
        sx={buttonStyles}
      >
        {buttonText}
      </Button>
      <FilePreviewSideModal
        file={file}
        onClose={() => setFile(null)}
        containerId={applicationData?.creditAuthId}
      />

      <CreditAndBackgroundReportModal
        show={show}
        application={applicationData}
        isSubmitted={isSubmitted}
        onCancel={() => setShow(false)}
      />
    </>
  );
};

const CreditAndBackgroundReportModal = ({
  show,
  application,
  onCancel,
  isSubmitted,
}) => {
  if (!show) {
    return null;
  }
  return (
    <BasicModal
      maxWidth={"lg"}
      title={isSubmitted ? "Credit Report" : "Pull Credit Report"}
      show={show}
      allowFullScreen
      onClose={onCancel}
    >
      <BorrowerCreditAndBackgroundReportForm
        application={application}
        type="credit"
      />
    </BasicModal>
  );
};

export default CellRendererPullCreditReportButton;
